import React__default from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { TabClasses } from './utils.js';

const tabPropTypes = {
  className: PropTypes.string,
  panel: PropTypes.node
};
const Tab = ({
  className,
  id,
  panel
}) => /*#__PURE__*/React__default.createElement("div", {
  className: cx(TabClasses.TAB_PANEL, className),
  id: id,
  role: "tablist"
}, panel);
Tab.propTypes = tabPropTypes;
Tab.displayName = 'NuiTab';
var Tab$1 = Tab;

export { Tab$1 as default };
